module.exports = __webpack_public_path__ + "img/yishi28.1319e530.jpg";